import {SharedConfigMerge} from "@/modules/mconfigs/utils/SharedConfigMerge";

export class ReleaseExportUtils {

    static resolveConfigExportSource(source, sharedConfigs) {
        if (!source || !source.data) {
            return null;
        }

        if (!source.sharedConfig) {
            return {data: source.data, sharedConfigUid: null};
        }

        if (sharedConfigs && sharedConfigs.find(s => s.uid === source.sharedConfig)) {
            return {data: source.data, sharedConfigUid: source.sharedConfig};
        }

        return null;
    }

    static resolveMasterExportSource(source) {
        if (!source || !source.data) {
            return null;
        }

        if (!source.sharedConfig) {
            return {data: source.data, sharedConfigUid: null};
        }

        if (!source.sharedConfigData) {
            return null;
        }

        return {
            data: SharedConfigMerge.mergeSharedIntoMap(source.sharedConfigData, source.data),
            sharedConfigUid: source.sharedConfig
        };
    }

}
